import camelcaseKeys from "camelcase-keys";
import { GetTransferTypesResponse as GetTransferTypesResponseV2 } from "@/redux/slices/vehicle/types";
import { GetRawTransferTypesRawResponse, GetTransferTypesResponse } from "./types";

export const transformGetTransferTypesResponse = (response: GetRawTransferTypesRawResponse): GetTransferTypesResponseV2 => {
  return {
    transferTypes: response._embedded.transfer_type.map((transferType) => camelcaseKeys(transferType, { deep: true })),
    page: {
      current: response.page,
      count: response.page_count,
      size: response.page_size,
      total: response.total_items,
    },
  };
};

export const transformTransferTypes = (res: GetRawTransferTypesRawResponse) => {
  const {
    _embedded: { transfer_type: items },
    page,
    page_count,
    page_size,
    total_items,
    _links,
  } = res;

  const response: GetTransferTypesResponse = {
    data: {
      items: items.map((i) => ({
        id: i.uuid,
        name: i.name,
        description: i.description,
        isActive: Boolean(i.is_active),
        isSpecialEvent: Boolean(i.is_special_event),
        isAdminOnly: Boolean(i.is_admin_only),
        isDispatchEnabled: Boolean(i.is_dispatch_enabled),
        order: i.order_score,
        multiplier: i.multiplier,
        type: i.type,
        taxStatus: i.tax_status,
      })),
      page: {
        current: page,
        count: page_count,
        size: page_size,
        total: total_items,
      },
    },
    links: _links,
  };

  return response;
};
